import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HostnameService {
  public get hostname(): string {
    return window.location.hostname;
  }

  public get pathName(): string {
    return window.location.pathname;
  }

  public get search(): string {
    return window.location.search;
  }
}
